import React from 'react';
import { Briefcase, Users, Handshake, Target } from 'lucide-react';

const ForCompanies = ({ t }) => {
  return (
    <section className="for-companies-section">
      <div className="container">
        <h2 className="section-title">{t.forCompanies.title}</h2>
        
        <div className="companies-content">
          <div className="companies-column">
            <div className="companies-intro">
              <Briefcase size={32} className="companies-icon" />
              <h3 className="companies-subtitle">{t.forCompanies.intro}</h3>
            </div>
            <ul className="companies-list">
              {t.forCompanies.types.map((type, index) => (
                <li key={index} className="companies-item">
                  <Users size={18} />
                  <span>{type}</span>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="companies-column">
            <div className="companies-intro">
              <Target size={32} className="companies-icon" />
              <h3 className="companies-subtitle">{t.forCompanies.differentials}</h3>
            </div>
            <ul className="companies-list">
              {t.forCompanies.diffItems.map((item, index) => (
                <li key={index} className="companies-item">
                  <Handshake size={18} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForCompanies;